///<reference path="../../../typings/tsd.d.ts" />
///<reference path="address-controller.ts" />

module address.directive {
    
    function link ($scope, $element: ng.IRootElementService, attrs, $ctrl: address.controller.AddressController){
        
        function showLoader() {
            $ctrl.config.loader.showLoader("Carregando dados do endereço..." );
            $ctrl.config.cepSearchError = false;
        };
        
        $element.bind('blur', () => {
            let currentValue = $element.val().replace(/(_+|-)/g, ''), cityCode;
            
            if (currentValue && currentValue.length == 8) {
                showLoader();
                
                $ctrl.getCep(currentValue).then(address => {
                    $ctrl.address = $.extend($ctrl.address, address);
                    cityCode = address.cityCode;
                    
                    // Check for empty street string
                    $ctrl.address.street = address.street.match(/^ +$/g) ? null : address.street;
                    
                    // Get cities list
                    $ctrl.getCities(address.countryCode, address.stateCode).then(cities => {
                        $ctrl.config.cities = cities;
                        $ctrl.address.cityCode = cityCode;
                        $ctrl.address.cityName = cities.filter(c => c.code == cityCode)[0].name;
                    }).finally(() => $ctrl.config.loader.hide());
                }).catch(zipCode => {
                    $ctrl.config.cepSearchError = true;
                    $ctrl.address = $.extend($ctrl.address, { 
                        countryCode: 'BR', 
                        stateCode: 'SP', 
                        zipCode: zipCode,
                        street: null,
                        adressNumber: null,
                        district: null,
                        cityName: null
                    }); 
                    $ctrl.config.loader.hide(); 
                });
            }
        });
    }

    export class AddressDiretive {
        restrict: string = 'A';
        replace: boolean = true;
        controller: string = 'addressController';
        controllerAs: string = 'dirCtrl';
        scope: boolean = true;
        bindToController: any = { config : '=', address : '=' };
        link: Function = link.bind(this);
        $ctrl: address.controller.AddressController;
    }
    
    angular.module('address').directive('dirAddress', () => new AddressDiretive());
};

